<ss-www-header
  [isTicketingPage]="isTicketingPage$() || isPageHeaderHidden()"
  class="fixed z-50 top-0 left-0 w-full"
></ss-www-header>
<div
  class="flex flex-col mx-auto min-h-full w-full max-w-screen-ssxl relative bg-ss-www-background"
  [ngClass]="{
    'mt-[60px]': isBannerVisible$ | async,
  }"
>
  <ss-www-notification-banner></ss-www-notification-banner>
  <router-outlet></router-outlet>
</div>

@if (!isTicketingPage$() && !isPageFooterHidden()) {
  <ss-www-footer></ss-www-footer>
}

@if (
  (isAppStable() && showTalkDesk() && !isTicketingPage$()) ||
  (isTicketingPage$() && (isMobileDevice$ | async) === false && showTalkDesk())
) {
  <ss-stx-shared-talkdesk-webchat
    [touchpointId]="config.touchpointId"
  ></ss-stx-shared-talkdesk-webchat>
}

<ss-www-page-loader></ss-www-page-loader>
